import { Button } from "@vitalsource/vstui";
import React from "react";
import styled from "styled-components";

const Container = styled.div`
  width: 44px;
  display: inline-block;

  button:disabled {
    opacity: 0.5;
    svg {
      fill: white !important;
    }
  }
`;

export default function WhiteIconButton({
  label,
  onClick,
  icon,
  className = "",
  disabled = false,
}) {
  return (
    <Container className={className}>
      <Button
        onClick={onClick}
        label={label}
        iconStart={icon}
        naked
        color="white"
        fullWidth
        disabled={disabled}
      />
    </Container>
  );
}
